import { ImagesEntity } from 'libs/gb-front/shared/models/shared.models'

/**
 * Interface for the list item data
 */
export interface SlimItemEntity {
  uuid: string
  auction: string
  alias: string
  name: string
  item_type: ItemTypeEnum
  main_image?: ItemImagesEntity | null
  images: ItemImagesEntity[]
  label: string | null
  show_label: boolean
  order: number
  order_hash: string
  image_cover: boolean
  bidding_item: BiddingItemEntity | null
  purchase_item: PurchaseItemEntity | null
  donation_item: DonationItemEntity | null
  raffle_item: RaffleItemEntity | null
  next_id: string | null
  prev_id: string | null
  notListLoaded?: boolean
  isStale?: boolean
}

export interface ItemsResponse {
  count: number
  next: string | null
  previous: string | null
  results: SlimItemEntity[]
  order_hash: string
}

export interface BiddingItemEntity {
  auction: string
  bid_strength_enabled: boolean
  bid_strength_percentage: number
  enable_live_auction: boolean
  hide_bidder: boolean
  hide_price: boolean
  hide_reserve_price: boolean
  hide_status_badge: boolean
  hide_units_available: boolean
  item: string
  item_type: ItemTypeEnum
  latest_bids: LatestActivity[]
  live_auction_item: boolean
  minimum_increment: number
  minimum_next_bid: number
  outbid_bidders: string[]
  outbid_sms: boolean
  reserve_price: number
  reserve_price_enabled: boolean
  sealed_bid_item: boolean
  starting_price: number
  units_available: number
  uuid: string
  winning_bids: WinningBidEntity[]
}

export interface WinningBidEntity {
  amount: number
  auction: string
  bidding_item: string
  created: string
  profile_full_name: string
  item: string
  minimum_next_bid: number
  profile_uuid: string
  uuid: string
}

export interface PurchaseItemEntity {
  auction: string
  item: string
  item_type: ItemTypeEnum
  pay_now: boolean
  unit_price: number
  units_available: number
  units_per_person: number
  units_remaining: number
  latest_purchases: LatestActivity[]
  uuid: string
}

export interface DonationItemEntity {
  auction: string
  donation_options: number[] | [] | null
  include_other_amount: boolean
  item: string
  item_type: ItemTypeEnum
  minimum_donation: number
  pay_now: boolean
  total_collected: number
  use_increments: boolean
  uuid: string
  latest_donations: LatestActivity[]
  target: number
}

export interface RaffleItemEntity {
  auction: string
  closed: boolean
  closed_timestamp: Date | undefined | null
  item: string
  item_type: ItemTypeEnum
  max_tickets_per_person: number
  pay_now: boolean
  prizes_available: number
  raffle_draws: RaffleDrawEntity[]
  show_number_of_tickets_available: boolean
  raffle_status: RaffleStatusEnum
  ticket_packages: TicketPackageEntity[]
  ticket_price: number
  tickets_available: number
  tickets_remaining: number
  latest_raffle_purchases: LatestActivity[]
  uuid: string
}

export interface RaffleDrawEntity {
  auction: string
  initiator: number
  item: string
  prize: number
  profile: string
  raffle_item: string
  raffle_ticket: string
  ticket_number: number
  uuid: string
}

export interface TicketPackageEntity {
  order: number
  price: number
  tickets: number
  uuid: string
}

export interface ItemImagesEntity extends ImagesEntity {
  item: string
  order: number
}

export interface LatestActivity {
  amount: number
  profile_full_name: string
  profile_uuid: string
  created: string
}

export enum ItemStatusEnum {
  Winning = 'winning',
  Won = 'won',
  Outbid = 'outbid',
  Lost = 'lost',
  BelowReserve = 'belowreserve',
  LostBelowReserve = 'lostbelowreserve',
  SoldOut = 'soldout',
}

export enum ItemTypeEnum {
  Bidding = 'bidding',
  Donation = 'donation',
  Purchase = 'purchase',
  Raffle = 'raffle',
}

export enum BidItemTypeEnum {
  Live = 'live',
  Sealed = 'sealed',
}

export enum RaffleStatusEnum {
  Open = 'open',
  Drawing = 'drawing',
  Closed = 'closed',
}

export interface PopperPayload {
  image: string
  item_uuid: string
  profile: string
  text: string
  type: PopperTypeEnum
}

export enum PopperTypeEnum {
  Donation = 'donation',
  Bid = 'bid',
  Purchase = 'purchase',
  Raffle = 'raffle',
}
